module.exports = __webpack_public_path__ + "img/album07_27.b54bea73.jpg";